import { NgModule, Type } from '@angular/core';
import { provideRoutes } from '@angular/router';

import { ForgotPasswordPage } from './forgot-password/forgot-password.page';
import { LoginPage } from './login/login.page';
import { RegisterPage } from './register/register.page';

export interface UIAuthPages {
  loginPage?: Type<any>;
  registerPage?: Type<any>;
  forgotPage?: Type<any>;
  guard?: {
      canActivate?: any[];
      canDeactivate?: any[];
      data?: any;
  };
}

export const CustomAuthComponents = (params: UIAuthPages) => provideRoutes([
  {
    path: 'auth',
    ...params.guard,
    children: [
      {
        path: 'login',
        component: params.loginPage || LoginPage,
      },
      {
        path: 'register',
        component: params.registerPage || RegisterPage,
      },
      {
        path: 'forgot-password',
        component: params.forgotPage || ForgotPasswordPage,
      },
      {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'login',
      },
    ],
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'auth',
  },
]);

@NgModule({
  imports: [],
  declarations: [],
})
export class AuthPageModule {}
